import PropTypes from 'prop-types';

const ForgotPasswordPropType = {
  username: PropTypes.string,
};

export default ForgotPasswordPropType;
